import {REPRESENTATION} from './representation.model';

/**
 * Formes sous lesquelles une échelle d'évaluation peut se présenter, dans l'ordre où le paramétrage
 * les propose.
 *
 * Les libellés n'en sont pas : une échelle d'évaluation ne mesure pas un indicateur, elle n'a donc
 * pas de jeu de mots tout fait à proposer d'un bout à l'autre — ses deux bornes disent déjà ce
 * qu'elle demande.
 */
export const SCALE_REPRESENTATIONS: REPRESENTATION[] = [REPRESENTATION.NUMBER, REPRESENTATION.VISUAL];
